var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "v-card",
        { attrs: { flat: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Name",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.quotation.name,
                          callback: function($$v) {
                            _vm.$set(_vm.quotation, "name", $$v)
                          },
                          expression: "quotation.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Reference number",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.quotation.reference_number,
                          callback: function($$v) {
                            _vm.$set(_vm.quotation, "reference_number", $$v)
                          },
                          expression: "quotation.reference_number"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "" } },
                    [
                      _c(
                        "v-currency-field",
                        _vm._b(
                          {
                            staticClass: "title-branding custom-input",
                            attrs: {
                              label: "Premium",
                              type: "tel",
                              filled: "",
                              readonly: ""
                            },
                            model: {
                              value: _vm.quotation.total_premium,
                              callback: function($$v) {
                                _vm.$set(_vm.quotation, "total_premium", $$v)
                              },
                              expression: "quotation.total_premium"
                            }
                          },
                          "v-currency-field",
                          _vm.$root.currency_config,
                          false
                        )
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Selected LPP™",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.quotation.selected_lpp_label,
                          callback: function($$v) {
                            _vm.$set(_vm.quotation, "selected_lpp_label", $$v)
                          },
                          expression: "quotation.selected_lpp_label"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Version",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.quotation.version,
                          callback: function($$v) {
                            _vm.$set(_vm.quotation, "version", $$v)
                          },
                          expression: "quotation.version"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md3: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          label: "Iteration",
                          type: "text",
                          readonly: ""
                        },
                        model: {
                          value: _vm.quotation.iteration,
                          callback: function($$v) {
                            _vm.$set(_vm.quotation, "iteration", $$v)
                          },
                          expression: "quotation.iteration"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          value:
                            _vm.quotation.cl_user.first_name +
                            " " +
                            _vm.quotation.cl_user.last_name,
                          label: "Created By",
                          type: "text",
                          readonly: ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", md6: "" } },
                    [
                      _c("v-text-field", {
                        staticClass: "title-branding custom-input",
                        attrs: {
                          filled: "",
                          value:
                            _vm.quotation.intermediary.FirstName +
                            " " +
                            _vm.quotation.intermediary.LastName,
                          label: "Intermediary",
                          type: "text",
                          readonly: ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "custom-button",
                  attrs: {
                    type: "button",
                    color: _vm.$vuetify.theme.dark
                      ? "primary lighten-1"
                      : "primary",
                    loading: _vm.requesting_pdf,
                    disabled:
                      _vm.requesting_new_version ||
                      _vm.creating_dealmaker_application,
                    small: _vm.isMobile
                  },
                  on: { click: _vm.viewPdf }
                },
                [_vm._v("\n                View PDF\n            ")]
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }